// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/file-image.js';

import { paths } from '../generated/file-image';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('file-image', Original, paths);
